"use client";

import { useRef } from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const getCaseStudyRoute = (title: string) => {
  const normalized = title.trim();
  if (normalized.includes("Alimentar")) return "/FoodAndBeverageCaseStudyPage";
  if (normalized.includes("Químicos")) return "/ChemicalProcessingCaseStudyPage";
  if (normalized.includes("Data Centers")) return "/DataCentersCaseStudyPage";
  if (normalized.includes("Energia")) return "/EnergyCaseStudyPage";
  if (normalized.includes("Minas")) return "/MiningCaseStudyPage";
  if (normalized.includes("Farmacêutica")) return "/PharmaceuticalCaseStudyPage";
  if (normalized.includes("Pasta")) return "/PulpPaperTissueCaseStudyPage";
  if (normalized.includes("Aço")) return "/SteelAndMetalsCaseStudyPage";
  if (normalized.includes("Transportes")) return "/TransportationCaseStudyPage";
  if (normalized.includes("Fabrico")) return "/VehicleManufacturingCaseStudyPage";
  if (normalized.includes("Madeiras")) return "/EngineeredWoodAndCementCaseStudyPage";
  return "/OtherIndustriesCaseStudyPage";
};
const stories = [{
  area: "FOOD & BEVERAGE",
  title: "Alimentar & Bebidas",
  summary: "Dezenas de operações em fábricas de processamento de alimentos dependem da tecnologia de pulverização da Spraying Systems Co. A nossa tecnologia produz milhares de milhões de gotas por dia em aplicações como revestimento, secagem por pulverização, limpeza, lavagem de tanques e lubrificação. Sempre com a máxima prioridade na segurança alimentar.",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.31.02.png?v=m9mdmwh8l7e",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.31.02.png?v=hu1n1bafaz8-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.31.02.png?v=g85v557l47s-wvc-sizes",
  alt: "Sistema de pulverização industrial em linha de montagem automotiva"
}, {
  area: "EENGINEERED WOOD & CEMENT\xA0",
  title: "Madeiras & Cimentos",
  summary: "As operações de pulverização na produção de materiais de construção requerem elevada precisão e eficiência. Os fabricantes precisam dos bicos de pulverização, sistemas automatizados, lanças e pistolas de alta pressão corretos para atingir os resultados pretendidos. A Spraying Systems Co. oferece todas estas soluções.",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.58.57.png?v=9t77rcfgo2",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.58.57.png?v=s98p82ss9pn-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.58.57.png?v=we108r3mh2-wvc-sizes",
  alt: "Equipamento de lavagem de tanques em aço inoxidável"
}, {
  area: "CHEMICAL PROCESSING",
  title: "Processos Químicos\xA0",
  summary: "Um desempenho inferior dos bicos pode originar condições inseguras, desperdício significativo ou mesmo paragens dispendiosas. Temos trabalhado com processadores químicos de todos os tipos e dimensões, ajudando a garantir qualidade, produtividade e eficiência, ao mesmo tempo que se atingem objetivos de sustentabilidade.\xA0",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/higienizacao_tanques.png?v=a5mwie6n68",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/higienizacao_tanques.png?v=2fyc7jmavfv-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/higienizacao_tanques.png?v=j7hmkzowcq-wvc-sizes",
  alt: "Torre de lavagem de gases com sistema de pulverização"
}, {
  area: "DATA CENTERS",
  title: "Data Centers",
  summary: "Garanta a continuidade operacional e melhore a eficiência com tecnologia de pulverização especializada para ambientes de data centers de missão crítica. Desde o arrefecimento evaporativo ao controlo de emissões e aos processos de tratamento de água, os nossos sistemas permitem aplicar o tamanho de gota, a distribuição e o caudal adequados — exatamente onde são necessários.",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.24.21.png?v=indehamw2yq",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.24.21.png?v=d9f5xokbhac-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.24.21.png?v=78wzu24gl1-wvc-sizes",
  alt: "Sistema de nebulização em estufa agrícola moderna"
}, {
  area: "ENERGY",
  title: "Energia\xA0",
  summary: "Muitos processos nas indústrias petroquímicas e de produção de energia são altamente sofisticados, intensivos em custos e fortemente regulados. Os nossos especialistas ajudam-no a aplicar a tecnologia de pulverização para otimizar os processos e aumentar a rentabilidade, em aplicações que abrangem desde a injeção de químicos até à supressão de poeiras.",
  partner: "Spraying Systems Co.®",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/arrefecimento_metal.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/arrefecimento_metal.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/arrefecimento_metal.webp-wvc-sizes",
  alt: "Processo de arrefecimento de metal fundido com bicos de pulverização"
}, {
  area: "MINING",
  title: "Minas",
  summary: "Controle e suprima de forma eficaz as poeiras com as nossas soluções de controlo de poeiras para a indústria mineira. As unidades de processamento mineiro utilizam correias transportadoras para movimentar sólidos, como minério ou carvão, desde os ROM Bins ou pontos de transferência até às zonas de processamento no local ou aos carregadores de navios",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.46.51.png?v=s74nyros2is",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.44.56.png?v=mu3spqpepo-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.44.56.png?v=mrm1acnhu2-wvc-sizes",
  alt: "Máquina de papel com sistema de revestimento por pulverização"
}];
export default function Success() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".story-header", {
        y: 24
      });
      gsap.to(".story-header", {
        opacity: 1,
        y: 0,
        duration: 0.64,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.set(".story-card", {
        y: 24
      });
      gsap.to(".story-card", {
        opacity: 1,
        y: 0,
        duration: 0.64,
        ease: "power3.out",
        stagger: 0.12,
        scrollTrigger: {
          trigger: ".story-grid",
          start: "top 85%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".story-header", ".story-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31375" id="industrialsuccesscases" ref={container} className="bg-background text-foreground py-24 md:py-44">
      <div className="mx-auto max-w-[1360px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8">
          <div className="lg:col-span-5 story-header" style={{
          opacity: 0
        }}>
            <p className="text-xs font-medium uppercase mb-6" style={{
            letterSpacing: "0.22em",
            color: "var(--muted-foreground)"
          }}>INDUSTRIES OVERVIEW</p>
            <h2 className="font-default font-medium leading-[1.06]" style={{
            fontSize: "clamp(2.125rem, 4.6vw, 4rem)",
            letterSpacing: "-0.024em"
          }}>Visão Geral &nbsp;Industrias<div contenteditable="false" style={{}}></div></h2>
          </div>

          <div className="lg:col-span-7 flex flex-col justify-between gap-8 story-header" style={{
          opacity: 0
        }}>
            <p className="font-default" style={{
            fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
            lineHeight: 1.55,
            letterSpacing: "-0.005em",
            color: "var(--muted-foreground)"
          }}>Ao longo de mais de 80 anos, temos trabalhado em centenas de indústrias para ajudar os nossos clientes a melhorar a qualidade, aumentar a produção, reduzir os custos operacionais e reforçar a sustentabilidade.</p>
            <div className="flex lg:justify-end">
              <Link to="/ApplicationsPage" className="group inline-flex items-center gap-2 text-foreground transition-colors hover:opacity-80" style={{
              fontSize: "0.9375rem"
            }}>
                <span>Ver todas as aplicações</span>
                <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.25} />
              </Link>
            </div>
          </div>
        </div>

        <div className="story-grid mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {stories.map((story, i) => <article key={i} data-index={i} className="story-card group relative flex flex-col overflow-hidden rounded-2xl border transition-all duration-[320ms] hover:-translate-y-1" style={{
          opacity: 0,
          backgroundColor: "var(--card)",
          borderColor: "var(--border)"
        }} onMouseEnter={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "var(--shadow-md)";
        }} onMouseLeave={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "none";
        }}>
              <div className="relative overflow-hidden" style={{
            aspectRatio: "16 / 10"
          }}>
                <img src={story.image} data-wvc-srcset={story.srcset} data-wvc-sizes={story.sizes} alt={story.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
                <div className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(180deg, hsl(215 80% 20% / 0.2) 0%, hsl(215 80% 20% / 0.05) 40%, hsl(215 80% 20% / 0.4) 100%)"
            }} />
                <span className="absolute top-6 left-6 text-xs font-medium uppercase" style={{
              letterSpacing: "0.22em",
              color: "var(--primary-foreground)"
            }}>
                  {story.area}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-6 md:p-8">
                <h3 className="font-default font-medium mb-4" style={{
              fontSize: "clamp(1.25rem, 1.8vw, 1.5rem)",
              lineHeight: 1.2,
              letterSpacing: "-0.018em"
            }}>
                  {story.title}
                </h3>
                <p className="font-default flex-1" style={{
              fontSize: "0.9375rem",
              lineHeight: 1.6,
              color: "var(--muted-foreground)"
            }}>
                  {story.summary}
                </p>

                <div className="mt-8 pt-6 flex items-center justify-between gap-4 border-t" style={{
              borderColor: "var(--border)"
            }}>
                  <span className="text-sm font-semibold" style={{
                color: "var(--foreground)"
              }}>
                    {story.partner}
                  </span>
                  <Button asChild variant="ghost" size="sm" className="h-auto px-2 py-1 gap-1.5 bg-transparent hover:bg-transparent text-primary hover:text-primary">
                    <Link to={getCaseStudyRoute(story.title)} className="group/link inline-flex items-center">
                      <span>Saber Mais</span>
                      <ArrowUpRight className="size-4 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" strokeWidth={1.25} />
                    </Link>
                  </Button>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}